import { GridColDef } from "@mui/x-data-grid-pro";
import { Button, IconButton } from "@mui/material";
import ItemStatus from "../../../../../../common/components/item_status";
import DynamicIcon from "../../../../../../common/components/dynamic_icon";
import dayjs from "dayjs";

/**
 * GenerateEntregaObrasVerificacaoListaColumn
 */

type Props = {
  onActionDeletar: (idInspecaoObra: number | null, openState: boolean) => void;
  onActionReportSimple: (idVistoria: number) => void;
  onActionReportFoto1: (idVistoria: number, openState: boolean, nroFoto: number) => void;
  onActionReportFoto2: (idVistoria: number, openState: boolean, nroFoto: number) => void;
  onEnterItemVerificacao: (idItemVerificacao: number, openNewTab: boolean) => void;

};

export const GenerateEntregaObrasVerificacaoListaColumn = ({

  onActionDeletar,
  onActionReportSimple,
  onActionReportFoto1,
  onActionReportFoto2,
  onEnterItemVerificacao,

}: Props): GridColDef[] => {

  const computeItemStatusTitle = (status: number) => {
    switch (status) {
      case 0:
        return "A";
      case 1:
        return "E";
      case 2:
        return "AR";
      default:
        return "?";
    }
  };

  const computeItemStatusColor = (status: number) => {
    switch (status) {
      case 0:
        return "yellow";
      case 1:
        return "green";
      case 2:
        return "blue";
      default:
        return "gray";
    }
  };

  const computeItemStatusDescription = (status: number) => {
    switch (status) {
      case 0:
        return "Em aberto";
      case 1:
        return "Entregue";
      case 2:
        return "Aguardando Reinspeção";
      default:
        return "?";
    }
  };


  const computeItemVistoriaTitle = (tipo: string) => {
    switch (tipo) {
      case "Cliente":
        return "Cliente";
      case "Construtora":
        return "Construtora";
      default:
        return "?";
    }
  };

  const computeItemVistoriaColor = (tipo: string) => {
    switch (tipo) {
      case "Cliente":
        return "yellow";
      case "Construtora":
        return "gray";
      default:
        return "blue";
    }
  };

  const computeItemVistoriaDescription = (tipo: string) => {
    switch (tipo) {
      case "Cliente":
        return "Cliente";
      case "Construtora":
        return "Construtora";
      default:
        return "?";
    }
  };


  return [
    {
      field: "status",
      filterable: false,
      headerName: "Status",
      minWidth: 50,
      width: 50,
      sortable: false,
      renderCell: (params) => (
        <div className="w-full h-full flex justify-center items-center">
          <ItemStatus
            size="autowidth"
            textSize="small"
            title={computeItemStatusTitle(params.value)}
            color={computeItemStatusColor(params.value)}
            description={computeItemStatusDescription(params.value)}
          />
        </div>
      )
    },
    {
      field: "tipoVistoria",
      filterable: false,
      headerName: "Vistoria",
      minWidth: 70,
      width: 70,
      sortable: false,
      renderCell: (params) => (
        <div className="w-full h-full flex justify-center items-center">
          <ItemStatus
            size="autowidth"
            textSize="small"
            title={computeItemVistoriaTitle(params.value)}
            color={computeItemVistoriaColor(params.value)}
            description={computeItemVistoriaDescription(params.value)}
          />
        </div>
      )
    },
    {
      field: "nomeCliente",
      filterable: false,
      headerName: "Cliente",
      flex: 1,
      minWidth: 160,
      width: 160,
      sortable: false,
      renderCell: ({ value }) => {
        return <div className="w-full break-normal">{value}</div>
      }
    },
    {
      field: "unidade",
      filterable: false,
      headerName: "Unidade",
      flex: 1,
      minWidth: 120,
      width: 120,
      sortable: false,
      renderCell: ({ value }) => {
        return <div className="w-full break-normal">{value}</div>
      }
    },
    // codigo - descricao
    {
      field: "checklist",
      filterable: false,
      headerName: "Checklist",
      flex: 1,
      minWidth: 160,
      width: 160,
      sortable: false,
      renderCell: ({ value }) => {
        return <div className="w-full break-normal">{value}</div>
      }
    },
    {
      field: "localVistoria",
      filterable: false,
      headerName: "Local de Vistoria",
      flex: 1,
      minWidth: 150,
      width: 150,
      sortable: false,
      renderCell: ({ value }) => {
        return <div className="w-full break-normal">{value}</div>
      }
    },

    {
      field: "dataInspecao",
      filterable: false,
      headerName: "Data Inspeção",
      minWidth: 80,
      width: 80,
      sortable: false,
      headerClassName: 'entregaObrasVistoria-header',
      renderCell: ({ value }) => {
        return <div>{value ? dayjs(value).format('DD/MM/YYYY') : null}</div>
      }
    },
    {
      field: "enter",
      filterable: false,
      headerName: "Itens da Verificação",
      sortable: false,
      width: 95,
      minWidth: 95,
      valueGetter: (_, row) => { return row['idEntregaObraCliente'] as number; },
      renderCell: ({ value }) => {
        return (
          <Button
            onMouseDown={(e) => {
              if (e.button === 1) {
                onEnterItemVerificacao(value, true);
              } else {
                onEnterItemVerificacao(value, e.ctrlKey);
              }
              e.preventDefault();
            }}
            sx={{
              fontSize: 9,
              paddingX: '.4rem',
              paddingY: 0,
              background: '#e6e6e6',
              borderLeft: '.2rem solid #d84a38',
              borderRadius: 0,
              color: 'black',
              fontWeight: 'normal',
            }}>
            Verificação
          </Button>
        );
      },
    },
    {
      field: "exportar",
      filterable: false,
      headerName: "Relatórios",
      sortable: false,
      minWidth: 130,
      width: 130,
      valueGetter: (_, row) => { return row['idEntregaObraCliente'] as number; },
      renderCell: ({ value }) => {
        return (
          <div className="flex flex-col items-center justify-center w-full h-full gap-1">
            <div className="flex ">
              <Button
                onMouseDown={(e) => {
                  onActionReportSimple(value);
                }}
                sx={{
                  fontSize: 11,
                  paddingX: '.4rem',
                  paddingY: 0,
                  background: '#e6e6e6',
                  borderLeft: '.2rem solid #35aa47',
                  borderRadius: 0,
                  color: 'black',
                  fontWeight: 'normal',
                }}>
                Simples
              </Button>
            </div>

            <div className="flex ">
              <Button
                onMouseDown={(e) => {
                  onActionReportFoto1(value, true, 1);
                }}
                sx={{
                  fontSize: 11,
                  paddingX: '.4rem',
                  paddingY: 0,
                  background: '#e6e6e6',
                  borderLeft: '.2rem solid #35aa47',
                  borderRadius: 0,
                  color: 'black',
                  fontWeight: 'normal',
                }}>
                Fotografico 1
              </Button>
            </div>

            <div className="flex">
              <Button
                onMouseDown={(e) => {
                  onActionReportFoto2(value, true, 2);
                }}
                sx={{
                  fontSize: 11,
                  paddingX: '.4rem',
                  paddingY: 0,
                  background: '#e6e6e6',
                  borderLeft: '.2rem solid #35aa47',
                  borderRadius: 0,
                  color: 'black',
                  fontWeight: 'normal',
                }}>
                Fotografico 2
              </Button>
            </div>
          </div>

        );
      },
    },
    {
      field: "pesquisaSatisfacao",
      filterable: false,
      headerName: "Pesquisa (%)",
      minWidth: 70,
      width: 70,
      sortable: false,
      headerClassName: 'entregaObrasVistoria-header',
      renderCell: ({ value }) => {
        return <div>{value !== null && value !== undefined ? `${value * 100}%` : '0%'}</div>
      }
      ,
    },
    {
      field: "totalNa",
      filterable: false,
      headerName: "NA",
      minWidth: 40,
      width: 40,
      sortable: false,
      headerClassName: 'entregaObrasVistoria-header',
    },
    {
      field: "totalA",
      filterable: false,
      headerName: "A",
      width: 40,
      minWidth: 40,
      sortable: false,
      headerClassName: 'entregaObrasVistoria-header',
    },
    {
      field: "totalR",
      filterable: false,
      headerName: "R",
      width: 40,
      minWidth: 40,
      sortable: false,
      headerClassName: 'entregaObrasVistoria-header',
    },
    {
      field: "totalX",
      filterable: false,
      headerName: "X",
      width: 40,
      minWidth: 40,
      sortable: false,
      headerClassName: 'entregaObrasVistoria-header',
    },
    {
      field: "totalRa",
      filterable: false,
      headerName: "RA",
      width: 40,
      minWidth: 40,
      sortable: false,
      headerClassName: 'entregaObrasVistoria-header',
    },
    {
      field: 'idEntregaObraCliente',
      sortable: false,
      filterable: false,
      headerName: 'Ações',
      width: 50,
      minWidth: 50,
      renderCell: (params) => {
        return (
          <div className="flex items-center justify-center w-full h-full gap-2">
            <div className="flex items-center justify-center w-full h-full gap-2">
              <IconButton
                onClick={() => onActionDeletar(params.value, true)}>
                <DynamicIcon nameIcon="DeleteForeverRounded" size={25} className="text-red-500" />
              </IconButton>
            </div>
          </div>
        );
      }
    },
  ];
}